import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { TodoStatus } from "features/TodoOploggSidebar/Todo/TodoComponent";
import { TodoElementWrapper } from "features/TodoOploggSidebar/Todo/TodoStyles";
import TodoBanner from "features/TodoOploggSidebar/Todo/todoList/todoElement/TodoBanner";
import TodoEdit from "features/TodoOploggSidebar/Todo/todoList/todoElement/TodoEdit";
import TodoFooter from "features/TodoOploggSidebar/Todo/todoList/todoElement/TodoFooter";
import { useState } from "react";
import { Text } from "shared/components/typography/TitleStyles";
import { UserRole } from "shared/types/roles";

export interface Todo {
  id: string;
  userId: string;
  title: string | null;
  description: string;
  dateCreated: string;
  role: UserRole;
  status: TodoStatus | null;
  priority: boolean | null;
  markedAsRead: boolean | null;
  trainNumber: string;
  vehicleSetTypes: string | null;
  transferOnShiftEnd: null;
  alarmTime: string | null;
  displayName: string | null;
}

type Props = {
  todo: Todo;
};
const TodoElement = ({ todo }: Props) => {
  const [selectedTodoId, setSelectedTodoId] = useState<string>("");

  const isShowingEdit = selectedTodoId === todo.id;

  return (
    <>
      <TodoElementWrapper>
        <TodoBanner todo={todo} />
        {isShowingEdit ? (
          <TodoEdit
            todo={todo}
            selectedTodoId={selectedTodoId}
            setSelectedTodoId={setSelectedTodoId}
          />
        ) : (
          <div>
            <Text>{todo.description}</Text>
            <TodoFooter
              todo={todo}
              onClick={() => {
                setSelectedTodoId(todo.id);
              }}
            />
          </div>
        )}
      </TodoElementWrapper>
      <DashedLine variant="secondary" />
    </>
  );
};

export default TodoElement;
